<app-header></app-header>

<ion-content
  id="menu-profit-pro"
  class="gray-content-bg"
  [class.desktop]="platformService?.platformType === platformService?.platformEnum?.desktop "
  [class.mobile]="platformService?.platformType !== platformService?.platformEnum?.mobile "
  [class.tablet]="platformService?.platformType !== platformService?.platformEnum?.tablet "
  *ngIf="(viewModel$ | async) as viewModel"
  [class.mobile-content]="platformService?.platformType === platformService?.platformEnum?.mobile"
>
  <div
    class="header-section"
    [class.mobile]="platformService?.platformType !== platformService?.platformEnum?.mobile "
  >
    <ion-grid [fixed]="true" (click)="closeDetailsPane()">
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
        [ngTemplateOutlet]="desktopHeader"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
        [ngTemplateOutlet]="tabletHeader"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
        [ngTemplateOutlet]="mobileHeader"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-grid>
  </div>
  <div class="lower-section" (click)="closeDetailsPane()">
    <ng-container
      *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile"
      [ngTemplateOutlet]="lowerSectionDesktopTablet"
      [ngTemplateOutletContext]="{viewModel:viewModel}"
    ></ng-container>

    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
      [ngTemplateOutlet]="lowerSectionMobile"
      [ngTemplateOutletContext]="{viewModel:viewModel}"
    ></ng-container>
  </div>
  <app-footer></app-footer>

  <ion-modal
    [isOpen]="isIngredientDetailModalIsOpen$ | async"
    (ionModalDidDismiss)="closeIngredientDetailsModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  >
    <ng-template>
      <app-ingredient-detail-touch-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [readyToShow]="viewModel.rightHandVal > 3"
        [product]="viewModel.lastSelectedProduct"
        [isOnline]="viewModel.isOnline"
        [marginTop]="marginTop"
        [pricingDisabled]="viewModel.pricingDisabled"
        [currentCalculations]="viewModel.currentCalculations"
        [showInfoIcon]="showSubHeaderInfoIcon"
        [cardData]="viewModel.selectedCard"
        [lockEdits]="viewModel.lockRecipeEdits"
        [isDefault]="viewModel.selectedCard?.isDefault || false"
        [defaultItemName]="viewModel.selectedCard?.itemName"
        (closeEvent)="closeIngredientDetailsModal()"
        (ellipsisEvent)="openProductEllipsisClick($event)"
        (productEvent)="openProductDetails($event)"
        (baseUnitEvent)="handleClickBaseUnit($event, viewModel.currentCalculations)"
        (conversionUnitEvent)="handleClickConversionUnit($event,viewModel.currentCalculations)"
        (resultUnitEvent)="handleClickResultsUnit($event,viewModel.currentCalculations)"
        (baseQuantityEvent)="updateBaseQunatity($event,viewModel.currentCalculations)"
        (conversionQuantityEvent)="updateConversionQuantity($event,viewModel.currentCalculations)"
        (saveChangesEvent)="saveUnitsOfMeasureCalculations($event, viewModel.currentCalculations, viewModel.currentUnitsOfMeasure, viewModel.lastSelectedProduct?.productNumber)"
        (infoIconEvent)="clickInfoIcon($event, false)"
        (uomDropdownClickEvent)="handleShowIngredientUom($event, viewModel.recipeId)"
        (noteInputBlurEvent)="handleIngredientNoteChange($event, viewModel.recipeId)"
        (quantityInputBlurEvent)="handleIngredientQuantityChange($event, viewModel.recipeId)"
        (dismissEvent)="closeIngredientDetailsModal()"
      >
      </app-ingredient-detail-touch-modal>
    </ng-template>
  </ion-modal>

  <ion-modal
    [isOpen]="isModalOpen$ | async"
    (ionModalDidDismiss)="handleGroupNameModalDismiss()"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'add-custom-group-modal-desktop'"
    id="add-custom-group-modal"
  >
    <ng-template>
      <app-add-custom-group-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [recipeName]="viewModel.recipeName"
        (dismissEvent)="handleGroupNameModalDismiss()"
        (submitEvent)="handleCustomGroupSubmit($event, viewModel.recipeId)"
      >
      </app-add-custom-group-modal>
    </ng-template>
  </ion-modal>

  <ion-modal
    [isOpen]="isEditDetailsModalOpen$ | async"
    (ionModalDidDismiss)="dismissEditDetailsModal()"
    [initialBreakpoint]="1"
    [breakpoints]="[0, 1]"
    [ngClass]="'ion-modal-touch'"
    id="edit-recipe-details-modal"
  >
    <ng-template>
      <app-edit-recipe-details-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [groupNames]="viewModel.groupNames"
        [step]="1"
        [description]="viewModel.description"
        [imageSrc]="viewModel.imageSrc"
        [groupName]="viewModel.groupName"
        [recipeName]="viewModel.recipeName"
        [recipeId]="viewModel.recipeId"
        (dismissEvent)="dismissEditDetailsModal()"
        (submitEvent)="handleEditDetailsSubmission($event, viewModel.recipeId)"
      >
      </app-edit-recipe-details-modal>
    </ng-template>
  </ion-modal>

  <ion-modal
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg upload-image-modal'"
    [isOpen]="isProfileImageModalOpen$ | async"
    (ionModalDidDismiss)="dismissProfileImageModal()"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
    id="add-profile-image-modal"
  >
    <ng-template>
      <app-upload-recipe-image-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [recipeId]="viewModel.recipeId"
        [currentSRC]="viewModel.imageSrc"
        (dismissEvent)="dismissProfileImageModal()"
        (submitEvent)="handleProfileImageOnSave($event, viewModel.recipeId)"
      >
      </app-upload-recipe-image-modal>
    </ng-template>
  </ion-modal>

  <ion-modal
    [isOpen]="isIngredientSearchModalOpen$ | async"
    (ionModalDidDismiss)="closeIngredientSearchModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  >
    <ng-template>
      <app-ingredient-search-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [ingredientName]=""
        [recipeSearchResult]="searchResultsForIngredient$"
        [productSearchResult]="searchResultsForProduct$"
        [searchTimeoutTracker]="searchTimeoutTracker$ | async"
        [showNonUsfFeature]="viewModel.mppFeatureflags.showAddNonUsfProductButton"
        (searchEvent)="handleNewIngredientSearchRequest($event)"
        (submitEvent)="handleNewIngredientSearchSubmission($event)"
        (dismissEvent)="closeIngredientSearchModal()"
        (viewAllProductsEvent)="handleProductViewAll($event)"
        (addNonUsfProductEvent)="handleAddNonUsfProductEvent()"
      >
      </app-ingredient-search-modal>
    </ng-template>
  </ion-modal>

  <app-add-non-usf-product-container
    (dismissEvent)="handleAddNonUsfProductDismissEvent()"
    (submitEvent)="handleAddNonUsfProducSubmitEvent($event)"
    (navigationEvent)="closeIngredientSearchModal()"
  ></app-add-non-usf-product-container>
</ion-content>

<ion-modal
  [isOpen]=" isDeleteIngredientModalOpen$ | async"
  (ionModalDidDismiss)="dismissDeleteIngredientModal()"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'delete-ingredient-modal'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  id="delete-ingredient-modal"
>
  <ng-template>
    <app-ingredient-deletion-modal
      class="ion-page"
      [platform]="platformService.platformType"
      [params]="recipeDetailService.currentDeleteParams"
      (dismissEvent)="dismissDeleteIngredientModal()"
      (submitEvent)="handleDeleteIngredientSubmit()"
    >
    </app-ingredient-deletion-modal>
  </ng-template>
</ion-modal>

<!-- Desktop Header -->
<ng-template #desktopHeader let-viewModel="viewModel">
  <ion-row class="first-row">
    <ion-col size="7">
      <ng-container [ngTemplateOutlet]="breadCrumbs"></ng-container>
    </ion-col>
    <ion-col offset="1" size="4">
      <ng-container [ngTemplateOutlet]="printDownloadShare"></ng-container>
    </ion-col>
  </ion-row>
  <ion-row class="last-row">
    <ion-col size="9.75" class="desktop-tablet-info">
      <ng-container
        [ngTemplateOutlet]="recipeImage"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="desktopTabletInfo"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
    <ion-col offset="0.25" size="2">
      <ion-row>
        <ion-col size="12">
          <ng-container
            [ngTemplateOutlet]="lockRecipeReverse"
            [ngTemplateOutletContext]="{viewModel:viewModel}"
          ></ng-container>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ng-container
            [ngTemplateOutlet]="costs"
            [ngTemplateOutletContext]="{viewModel:viewModel}"
          ></ng-container>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        [ngTemplateOutlet]="tabSelection"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Tablet Header -->
<ng-template #tabletHeader let-viewModel="viewModel">
  <ion-row class="first-row">
    <ion-col size="7">
      <ng-container [ngTemplateOutlet]="breadCrumbs"></ng-container>
    </ion-col>
    <ion-col offset="4" size="1">
      <ng-container
        [ngTemplateOutlet]="ellipsis"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12" class="desktop-tablet-info">
      <ng-container
        [ngTemplateOutlet]="recipeImage"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="desktopTabletInfo"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row class="last-row">
    <ion-col size="3">
      <ng-container
        [ngTemplateOutlet]="lockRecipe"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
    <ion-col offset="5" size="4">
      <ng-container
        [ngTemplateOutlet]="costs"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        [ngTemplateOutlet]="tabSelection"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Mobile Header -->
<ng-template #mobileHeader let-viewModel="viewModel">
  <ion-row>
    <ion-col size="9">
      <p class="text-title mobile-recipe-name">
        {{viewModel.recipeName | truncateWithEllipsis: viewModel.truncateCount}}
      </p>
    </ion-col>
    <ion-col size="2" offset="1">
      <ng-container
        [ngTemplateOutlet]="ellipsis"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="3.5">
      <ng-container
        [ngTemplateOutlet]="recipeImageMobile"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
    <ion-col offset="0.5" size="8">
      <ng-container
        [ngTemplateOutlet]="groupDescription"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" class="lock">
      <ng-container
        [ngTemplateOutlet]="lockRecipe"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <ng-container
        [ngTemplateOutlet]="portion"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #portion let-viewModel="viewModel">
  <div
    class="portion"
    (click)="clickShowHidePortion(viewModel.details.showPortion)"
  >
    <hr />
    <p>{{ 'i18n.menuProfitPro.recipeDetail.portion' | translate}}</p>
    <ion-icon
      [name]="viewModel.details.showPortion ? 'chevron-up-outline' :'chevron-down-outline' "
    >
    </ion-icon>
  </div>
  <app-edit-portion
    *ngIf="viewModel.details.showPortion"
    [yield]="viewModel.yield"
    [serving]="viewModel.servingSizeQuantity"
    [servingPerRecipe]="viewModel.servingPerBatch"
    [servingUOM]="viewModel.servingSizeUom ?? 'i18n.menuProfitPro.recipeDetail.cup'"
    [lockEdits]="viewModel.lockRecipeEdits"
    [yieldUOM]="viewModel.displayYieldUom ?? 'i18n.menuProfitPro.recipeDetail.cup'"
    [recipeDetailPage]="true"
    [platform]="platformService.platformType"
    (yieldValueEvent)="handleYieldChange($event, viewModel.recipeId)"
    (servingValueEvent)="handleServingChange($event, viewModel.recipeId)"
    (servingPerRecipeEvent)="handleServingPerRecipeChange($event, viewModel.recipeId)"
    (servingUOMEvent)="handleShowServingUOM($event, viewModel.recipeId)"
    (yieldUOMEvent)="handleShowYieldUOM($event, viewModel.recipeId)"
  >
  </app-edit-portion>
  <div *ngIf="!viewModel.details.showPortion" class="portion-lower">
    <div class="details-mobile">
      <p>
        <span>{{ 'i18n.menuProfitPro.recipeDetail.yield' | translate}}: </span
        ><span class="placeholder"
          >{{(viewModel.yield ?? '-') + ' ' + ((viewModel.displayYieldUom ??
          'i18n.menuProfitPro.recipeDetail.cup') | translate)}}
        </span>
      </p>
      <img class="seperate" src="assets/images/separator.png" />
      <p>
        <span
          >{{ 'i18n.menuProfitPro.recipeDetail.servingSize' | translate}}: </span
        ><span class="placeholder"
          >{{(viewModel.servingSizeQuantity ?? '-') + ' ' +
          ((viewModel.servingSizeUom ?? 'i18n.menuProfitPro.recipeDetail.cup') |
          translate)}}
        </span>
      </p>
      <img class="seperate" src="assets/images/separator.png" />
      <p>
        <span
          >{{ 'i18n.menuProfitPro.recipeDetail.servingPerBatch' | translate}}: </span
        ><span class="placeholder">{{viewModel.servingPerBatch ?? 1}} </span>
      </p>
    </div>
    <div class="costs-mobile">
      <p>
        <span class="money">{{ viewModel.costPerServing ?? 0 | currency}} </span
        ><span
          >{{ 'i18n.menuProfitPro.recipeDetail.costServing2' | translate}}</span
        >
      </p>
      <p>
        <span class="money">{{ viewModel.cost ?? 0 | currency}} </span
        ><span
          >{{ 'i18n.menuProfitPro.recipeDetail.costRecipe2' | translate}}</span
        >
      </p>
    </div>
  </div>
</ng-template>

<ng-template #groupDescription let-viewModel="viewModel">
  <div class="groupDesc">
    <p class="text-body">{{viewModel.groupName}}</p>
    <p class="five-line-text text-body">{{viewModel.description}}</p>
  </div>
</ng-template>

<ng-template #IngredientsLaunch let-viewModel="viewModel">
  <ion-item
    class="launch"
    [attr.data-cy]="'ingredients-launch'"
    button="true"
    detail="true"
    (click)="goToIngredients(viewModel.recipeId)"
  >
    <ion-label class="text-heading">
      {{ 'i18n.menuProfitPro.recipeDetail.tabIngredient' | translate }}
    </ion-label>
    <ion-badge mode="ios">
      {{ (viewModel.transformedIngredientData ?? []).length}}
    </ion-badge>
  </ion-item>
</ng-template>

<ng-template #PreperationsLaunch let-viewModel="viewModel">
  <ion-item
    class="launch"
    [attr.data-cy]="'preperations-launch'"
    button="true"
    detail="true"
  >
    <ion-label class="text-heading">
      {{ 'i18n.menuProfitPro.recipeDetail.tabPreperation' | translate }}
    </ion-label>
    <ion-badge mode="ios">
      {{ (viewModel.instructionList ?? []).length}}
    </ion-badge>
  </ion-item>
</ng-template>

<ng-template #UnitOfMeasureLaunch let-viewModel="viewModel">
  <ion-item
    class="launch"
    [attr.data-cy]="'unit-of-measure-launch'"
    button="true"
    detail="true"
  >
    <ion-label class="uom text-heading">
      {{ 'i18n.menuProfitPro.recipeDetail.launchUOM' | translate }}
    </ion-label>
  </ion-item>
</ng-template>

<ng-template #lowerSectionDesktopTablet let-viewModel="viewModel">
  <ng-container
    *ngIf="viewModel.details.selectedTab === tabRef.ingredients"
    [ngTemplateOutlet]="desktopTabletList"
    [ngTemplateOutletContext]="{viewModel:viewModel}"
  ></ng-container>

  <ng-container
    *ngIf="viewModel.details.selectedTab === tabRef.unitOfMeasure"
    [ngTemplateOutlet]="unitOfMeasureInteraction"
    [ngTemplateOutletContext]="{viewModel:viewModel}"
  >
  </ng-container>
</ng-template>

<ng-template #lowerSectionMobile let-viewModel="viewModel">
  <ion-row>
    <ion-col size="12">
      <ng-container
        [ngTemplateOutlet]="IngredientsLaunch"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngIf="viewModel.mppFeatureflags.showRecipeDetailPrepTab"
        [ngTemplateOutlet]="PreperationsLaunch"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngIf="viewModel.mppFeatureflags.showRecipeDetailUomTab"
        [ngTemplateOutlet]="UnitOfMeasureLaunch"
        [ngTemplateOutletContext]="{viewModel:viewModel}"
      ></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #unitOfMeasureInteraction let-viewModel="viewModel">
  <div
    [class.constrain]="platformService.platformEnum.desktop === platformService.platformType"
  >
    <ion-card
      class="measure-card"
      [class.tablet]="platformService.platformEnum.tablet === platformService.platformType"
    >
      <app-ingredient-units-of-measure
        [platform]="platformService.platformType"
        [baseUnit]="viewModel.currentCalculations?.displayBaseUnit"
        [baseQuantity]="viewModel.currentCalculations?.baseQuantity"
        [conversionUnit]="viewModel.currentCalculations?.displayConversionUnit"
        [conversionQuantity]="viewModel.currentCalculations?.conversionQunatity"
        [solvedUnit]="viewModel.currentCalculations?.displayTestUnit"
        [solvedQuantity]="viewModel.currentCalculations?.testQuantity"
        [solvedCost]="viewModel.currentCalculations?.testCost"
        [baseUnits]="viewModel.currentCalculations?.allowedUnits"
        [conversionUnits]="viewModel.currentCalculations?.possibleConversionUnits"
        [lockEdits]="viewModel.lockRecipeEdits"
        [disableInputs]="!viewModel.displayYieldUom || !viewModel.yield"
        (infoIconEvent)="clickInfoIcon($event, !viewModel.displayYieldUom || !viewModel.yield)"
        (baseUnitEvent)="handleClickBaseUnit($event, viewModel.currentCalculations)"
        (conversionUnitEvent)="handleClickConversionUnit($event,viewModel.currentCalculations)"
        (resultUnitEvent)="handleClickResultsUnit($event,viewModel.currentCalculations)"
        (baseQuantityEvent)="updateBaseQunatity($event,viewModel.currentCalculations)"
        (conversionQuantityEvent)="updateConversionQuantity($event,viewModel.currentCalculations)"
        (saveChangesEvent)="saveUnitOfMeasureForRecipe(viewModel.currentCalculations, viewModel.currentUnitsOfMeasure, viewModel.recipeId)"
      >
      </app-ingredient-units-of-measure>
    </ion-card>
  </div>
</ng-template>

<ng-template #desktopTabletList let-viewModel="viewModel">
  <ion-grid class="ingredients-container">
    <ion-row>
      <ion-col [size]="viewModel.leftHandVal">
        <app-ingredients-desktop-tablet
          [ingredients]="viewModel.transformedIngredientData"
          [containerSize]="viewModel.leftHandVal"
          [searchKey]="''"
          [platform]="platformService.platformType"
          [lockEdits]="viewModel.lockRecipeEdits"
          (addIngredientsEvent)="openIngredientSearchModal()"
          (uomDropdownClickEvent)="handleShowIngredientUom($event, viewModel.recipeId)"
          (noteInputBlurEvent)="handleIngredientNoteChange($event, viewModel.recipeId)"
          (quantityInputBlurEvent)="handleIngredientQuantityChange($event, viewModel.recipeId)"
          (ellipsisEvent)="handleIngredientEllipsisClick($event, viewModel.recipeId)"
          (nameClickEvent)="onNameClick($event)"
          (costInfoIconEvent)="clickCostInfoIcon($event)"
          (dismissCostInfoPopover)="handleDismissCostInfoPopover()"
        >
        </app-ingredients-desktop-tablet>
      </ion-col>
      <ion-col [size]="viewModel.rightHandVal" (click)="eatClick($event)">
        <app-ingredient-details
          *ngIf="viewModel.rightHandVal > 1"
          [platform]="platformService.platformType"
          [readyToShow]="viewModel.rightHandVal > 3"
          [product]="viewModel.lastSelectedProduct"
          [isOnline]="viewModel.isOnline"
          [marginTop]="marginTop"
          [pricingDisabled]="viewModel.pricingDisabled"
          [currentCalculations]="viewModel.currentCalculations"
          [showInfoIcon]="showSubHeaderInfoIcon"
          [lockEdits]="viewModel.lockRecipeEdits"
          [isDefault]="viewModel.selectedCard?.isDefault || false"
          [defaultItemName]="viewModel.selectedCard?.itemName"
          (closeEvent)="closeDetailsPane()"
          (ellipsisEvent)="openProductEllipsisClick($event)"
          (productEvent)="openProductDetails($event)"
          (baseUnitEvent)="handleClickBaseUnit($event, viewModel.currentCalculations)"
          (conversionUnitEvent)="handleClickConversionUnit($event,viewModel.currentCalculations)"
          (resultUnitEvent)="handleClickResultsUnit($event,viewModel.currentCalculations)"
          (baseQuantityEvent)="updateBaseQunatity($event,viewModel.currentCalculations)"
          (conversionQuantityEvent)="updateConversionQuantity($event,viewModel.currentCalculations)"
          (saveChangesEvent)="saveUnitsOfMeasureCalculations($event, viewModel.currentCalculations, viewModel.currentUnitsOfMeasure, viewModel.lastSelectedProduct?.productNumber)"
          (infoIconEvent)="clickInfoIcon($event, false)"
        >
        </app-ingredient-details>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<ng-template #breadCrumbs>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</ng-template>

<ng-template #printDownloadShare>
  <!-- put icons here -->
</ng-template>

<ng-template #ellipsis let-viewModel="viewModel">
  <div data-cy="list-banner-ellipsis-section">
    <ion-icon
      class="ellipsis"
      [class.disabled-lock]="viewModel.lockRecipeEdits"
      data-cy="list-banner-ellipsis-icon"
      name="ellipsis-vertical"
      (click)="showMobileActions(viewModel.recipeId, viewModel.lockRecipeEdits)"
    ></ion-icon>
  </div>
</ng-template>

<ng-template #recipeImageMobile let-viewModel="viewModel">
  <div>
    <img
      *ngIf="viewModel.imageSrc"
      class="recipe-image mobile"
      [attr.data-cy]="'recipe-card-image'"
      [src]="viewModel.imageSrc"
    />
    <div
      *ngIf="!viewModel.imageSrc"
      data-cy="recipe-no-image-icon"
      class="recipe-image mobile"
    >
      <ion-icon name="restaurant"></ion-icon>
    </div>
    <div class="edit-image mobile">
      <ion-icon
        src="../../../../assets/icon/pencil-green.svg"
        (click)="!viewModel.lockRecipeEdits && openProfileImageModal()"
      ></ion-icon>
    </div>
  </div>
</ng-template>

<ng-template #recipeImage let-viewModel="viewModel">
  <div>
    <img
      *ngIf="viewModel.imageSrc"
      class="recipe-image"
      [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
      [attr.data-cy]="'recipe-card-image'"
      [src]="viewModel.imageSrc"
    />
    <div
      *ngIf="!viewModel.imageSrc"
      data-cy="recipe-no-image-icon"
      [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
      class="recipe-image"
    >
      <ion-icon name="restaurant"></ion-icon>
    </div>
    <div
      class="edit-image"
      [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
    >
      <ion-icon
        src="../../../../assets/icon/pencil-green.svg"
        (click)="!viewModel.lockRecipeEdits && openProfileImageModal()"
        [class.disabled]="viewModel.lockRecipeEdits"
      ></ion-icon>
    </div>
  </div>
</ng-template>

<ng-template #lockRecipeReverse let-viewModel="viewModel">
  <div class="lock-indicator-toggle-container reverse">
    <ion-toggle
      id="lock-indicator-toggle"
      data-cy="lock-indicator-toggle"
      mode="ios"
      [(ngModel)]="viewModel.lockInd"
      [class.disabled-toggle]="!viewModel.canEditLockToggle"
      [disabled]="!viewModel.canEditLockToggle"
      (ionChange)="onLockIndToggleChange($event, viewModel.recipeId)"
    >
    </ion-toggle>
    <ion-icon
      id="hover-info-trigger"
      data-cy="lock-information-icon"
      name="information-circle-outline"
      color="primary"
    ></ion-icon>
    {{ 'i18n.menuProfitPro.recipeDetail.lock' | translate }}

    <ion-popover
      data-cy="lock-ind-popover"
      class="lock-ind-popover"
      mode="ios"
      trigger="hover-info-trigger"
      trigger-action="hover"
      side="top"
      (didPresent)="shouldCloselockInfoPopover($event)"
      (didDismiss)="removeWindowListener()"
    >
      <ng-template>
        <app-lock-info-popover></app-lock-info-popover>
      </ng-template>
    </ion-popover>
  </div>
</ng-template>

<!-- break out into component -->
<ng-template #lockRecipe let-viewModel="viewModel">
  <div
    class="lock-indicator-toggle-container"
    [class.mobile]="platformService.platformType === platformService.platformEnum.mobile"
    [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
  >
    {{ 'i18n.menuProfitPro.recipeDetail.lock' | translate }}
    <ion-icon
      id="hover-info-trigger"
      data-cy="lock-information-icon"
      name="information-circle-outline"
      color="primary"
    ></ion-icon>
    <ion-toggle
      id="lock-indicator-toggle"
      data-cy="lock-indicator-toggle"
      [class.disabled-toggle]="!viewModel.canEditLockToggle"
      mode="ios"
      [(ngModel)]="viewModel.lockInd"
      [disabled]="!viewModel.canEditLockToggle"
      (ionChange)="onLockIndToggleChange($event, viewModel.recipeId)"
    >
    </ion-toggle>
    <ion-popover
      data-cy="lock-ind-popover"
      class="lock-ind-popover"
      mode="ios"
      trigger="hover-info-trigger"
      trigger-action="hover"
      side="top"
      (didPresent)="shouldCloselockInfoPopover($event)"
      (didDismiss)="removeWindowListener()"
    >
      <ng-template>
        <app-lock-info-popover></app-lock-info-popover>
      </ng-template>
    </ion-popover>
  </div>
</ng-template>

<ng-template #costs let-viewModel="viewModel">
  <div class="costs-container">
    <div class="costs">
      <p class="label text-body-preserved-margin">
        {{ 'i18n.menuProfitPro.recipeDetail.costServing' | translate}}
      </p>
      <p class="cost text-heading-preserved-margin">
        {{ viewModel.costPerServing | currency}}
      </p>
    </div>
    <div class="costs">
      <p class="label text-body-preserved-margin">
        {{ 'i18n.menuProfitPro.recipeDetail.costRecipe' | translate}}
      </p>
      <p class="cost text-heading-preserved-margin">
        {{ viewModel.cost | currency}}
      </p>
    </div>
  </div>
</ng-template>

<ng-template #desktopTabletInfo let-viewModel="viewModel">
  <div class="container" [class.in-edit]="isEditingNameDescription">
    <div>
      <p
        class="text-large-title desktop-recipe-name"
        *ngIf="!isEditingNameDescription"
      >
        {{viewModel.recipeName | truncateWithEllipsis: viewModel.truncateCount}}
      </p>
      <ion-input
        class="long-form"
        [(ngModel)]="viewModel.recipeName"
        *ngIf="isEditingNameDescription"
        (ionBlur)="handleRecipeNameChange($event,viewModel.recipeId)"
        [placeholder]="'Recipe Name'"
        [maxlength]="100"
        (ngModelChange)="onNameChange($event)"
        [class.error]="!!nameIsDuplicate || !!nameContainsEmojis || !!nameIsEmpty"
      ></ion-input>
      <ion-icon
        *ngIf="isEditingNameDescription"
        [src]="'../../../../assets/icon/pencil-green-fill.svg'"
        (click)="toggleEditNameDescription()"
      ></ion-icon>
      <ion-icon
        *ngIf="!isEditingNameDescription"
        [src]=" '../../../../assets/icon/pencil-green.svg'"
        (click)="!viewModel.lockRecipeEdits && toggleEditNameDescription()"
        [class.disabled]="viewModel.lockRecipeEdits"
      ></ion-icon>
    </div>
    <div
      class="error-messages"
      *ngIf="isEditingNameDescription && (nameContainsEmojis || nameIsDuplicate || nameIsEmpty)"
    >
      <p
        *ngIf="nameContainsEmojis || nameIsEmpty"
        class="invalid-character text-small"
      >
        {{ 'i18n.menuProfitPro.createModal.invalidCharacterError' | translate }}
      </p>
      <p *ngIf="nameIsDuplicate" class="invalid-character text-small">
        {{ 'i18n.menuProfitPro.createModal.nameDuplicateError' | translate }}
      </p>
    </div>
    <div>
      <ion-item
        id="recipe-group"
        data-cy="recipe-detail-group-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="!viewModel.lockRecipeEdits && handleShowGroup($event, viewModel.recipeId)"
        [disabled]="viewModel.lockRecipeEdits"
      >
        <ion-label
          data-cy="recipe-detail-group-label"
          [class.gray]="!viewModel.groupName"
        >
          {{!!viewModel.groupName ? viewModel.groupName :
          ('i18n.menuProfitPro.recipeDetail.group' | translate)}}
        </ion-label>
      </ion-item>
      <p class="description two-line-text" *ngIf="!isEditingNameDescription">
        {{viewModel.description}}
      </p>
      <ion-input
        class="long-form"
        [(ngModel)]="viewModel.description"
        *ngIf="isEditingNameDescription"
        (ionBlur)="handleDescriptionChange($event, viewModel.recipeId)"
        [placeholder]="'Recipe description'"
        [maxlength]="100"
        (ngModelChange)="onDescriptionChange($event)"
        [class.error]="!!descriptionContainsEmojis"
      ></ion-input>
    </div>
    <div
      class="error-messages"
      *ngIf="isEditingNameDescription && (descriptionContainsEmojis)"
    >
      <p
        *ngIf="descriptionContainsEmojis"
        class="invalid-character bump text-small"
      >
        {{ 'i18n.menuProfitPro.createModal.invalidCharacterError' | translate }}
      </p>
    </div>
    <div>
      <p class="text-medium">
        {{ 'i18n.menuProfitPro.recipeDetail.servingSize' | translate}}
      </p>
      <ion-input
        [(ngModel)]="viewModel.servingSizeQuantity"
        [placeholder]="'-'"
        [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
        (ionBlur)="handleServingInputChange($event,viewModel.recipeId)"
        customDecimal
        [maxLeftHandDigits]="5"
        [maxPrecision]="2"
        [disabled]="viewModel.lockRecipeEdits"
        class="input-standard input-numeric"
      ></ion-input>
      <ion-item
        id="recipe-serv-uom"
        data-cy="recipe-detail-serv-uom-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="!viewModel.lockRecipeEdits && handleShowServingUOM($event, viewModel.recipeId)"
        [disabled]="viewModel.lockRecipeEdits"
      >
        <ion-label
          data-cy="recipe-detail-serv-uom-label"
          [class.gray]="!viewModel.servingSizeUom"
          class="text-body"
        >
          {{(!!viewModel.servingSizeUom ? viewModel.servingSizeUom :
          'i18n.menuProfitPro.recipeDetail.cup') | translate}}
        </ion-label>
      </ion-item>
    </div>
    <div>
      <p class="text-medium">
        {{ 'i18n.menuProfitPro.recipeDetail.servingPerRecipe' | translate}}
      </p>
      <ion-input
        [(ngModel)]="viewModel.servingPerBatch"
        [placeholder]="'-'"
        [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
        (ionBlur)="handleServingPerRecipeInputChange($event,viewModel.recipeId)"
        numeric
        maxlength="4"
        [disabled]="viewModel.lockRecipeEdits"
        class="input-standard input-numeric"
      ></ion-input>
    </div>
    <div>
      <p class="text-medium">
        {{ 'i18n.menuProfitPro.recipeDetail.yield' | translate}}
      </p>
      <ion-input
        [(ngModel)]="viewModel.yield"
        [placeholder]="'-'"
        [class.tablet]="platformService.platformType === platformService.platformEnum.tablet"
        (ionBlur)="handleYieldInputChange($event, viewModel.recipeId)"
        customDecimal
        [maxLeftHandDigits]="7"
        [maxPrecision]="2"
        [disabled]="viewModel.lockRecipeEdits"
        class="input-standard input-numeric"
      ></ion-input>
      <ion-item
        id="recipe-yield-uom"
        data-cy="recipe-detail-yield-uom-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="!viewModel.lockRecipeEdits && handleShowYieldUOM($event, viewModel.recipeId)"
        [disabled]="viewModel.lockRecipeEdits"
      >
        <ion-label
          data-cy="recipe-detail-yield-uom-label"
          [class.gray]="!viewModel.displayYieldUom"
          class="text-body"
        >
          {{(!!viewModel.displayYieldUom ? viewModel.displayYieldUom :
          'i18n.menuProfitPro.recipeDetail.cup') | translate}}
        </ion-label>
      </ion-item>
    </div>
  </div>
</ng-template>

<ng-template #tabSelection let-viewModel="viewModel">
  <div class="tab-selection">
    <div
      class="tab"
      [id]="'tabs-1'"
      [class.selected]="viewModel.details.selectedTab === tabRef.ingredients"
      (click)="changeSelectedTab(tabRef.ingredients)"
    >
      <div>
        {{ 'i18n.menuProfitPro.recipeDetail.tabIngredient' | translate }}
      </div>
      <ion-badge mode="ios" class="count">
        {{ (viewModel.transformedIngredientData ?? []).length}}
      </ion-badge>
    </div>
    <!-- <div
      *ngIf="viewModel.mppFeatureflags.showRecipeDetailPrepTab"
      class="tab"
      [id]="'tabs-2'"
      [class.selected]="viewModel.details.selectedTab === tabRef.preperation"
      (click)="changeSelectedTab(tabRef.preperation)"
    >
      <div>
        {{ 'i18n.menuProfitPro.recipeDetail.tabPreperation' |translate }}
      </div>
      <ion-badge mode="ios" class="count">
        {{ (viewModel.instructionList ?? []).length}}
      </ion-badge>
    </div> -->
    <div
      *ngIf="viewModel.mppFeatureflags.showRecipeDetailUomTab"
      class="tab"
      [id]="'tabs-3'"
      [class.selected]="viewModel.details.selectedTab === tabRef.unitOfMeasure"
      (click)="changeSelectedTab(tabRef.unitOfMeasure)"
    >
      <div>{{ 'i18n.menuProfitPro.recipeDetail.tabUOM' | translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #noSearchResults>
  <div
    data-cy="ingredients-no-search-results-container"
    class="ingredients-no-search-results"
  >
    <span
      data-cy="ingredients-no-search-results-text"
      class="text-large-title text-gray"
    >
      {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
    </span>
    <span
      data-cy="ingredients-no-search-results-subtext"
      class="text-heading text-black"
    >
      {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
    </span>
  </div>
</ng-template>
